import React, { useState } from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormGroup from '@material-ui/core/FormGroup'
import CoachCardSm from 'components/coach-card-small'
import { useStyles, Header, HelperText, NextButton } from '../styles'
import { useWizardFormContext } from 'components/wizard-form/context'
import { useFormContext, Controller } from 'react-hook-form'
import { Questionnaire } from '../constants'

const SelectAvailability = ({ coach }) => {
  const classes = useStyles()
  const { advance } = useWizardFormContext()
  const { register, control } = useFormContext()
  const currentStep = 3
  const answers = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ]

  const [availableDays, setAvailableDays] = useState([])

  const toggleChecked = (value, index, onChange) => {
    const dayIndex = availableDays.indexOf(value)

    if (dayIndex === -1) {
      setAvailableDays([...availableDays, value])
      onChange(value)
    } else {
      // remove day from availableDays array
      setAvailableDays([
        ...availableDays.slice(0, dayIndex),
        ...availableDays.slice(dayIndex + 1),
      ])
      onChange('')
    }
  }

  return (
    <Grid container spacing={1}>
      <Grid item md={8} xs={12}>
        <Header variant="h4">Coaching Request</Header>
        <HelperText variant="body1">
          These questions will help the coach to find out more about you and the
          way you golf.
        </HelperText>
      </Grid>
      <Grid item md={4} xs={12} style={{ marginLeft: 'auto' }}>
        <CoachCardSm coach={coach} />
      </Grid>
      <Grid container item>
        <Grid item md={8} xs={12}>
          <Typography variant="h6" className={classes.sectionTitle}>
            {Questionnaire.AVAILABILITY.question} You can select more than one.
          </Typography>
          <FormGroup>
            <Grid container spacing={3}>
              {answers.map((answer, index) => (
                <Controller
                  key={index}
                  control={control}
                  name={`questionnaire[${currentStep}].answer[${index}]`}
                  defaultValue=""
                  render={({ onChange, value }) => (
                    <Grid item md={3} xs={6}>
                      <FormControlLabel
                        classes={{
                          root: classes.customControlLabel,
                          label: classes.formControlLabel,
                        }}
                        label={`${answer}s`}
                        control={
                          <Checkbox
                            classes={{
                              root: classes.root,
                              checked: classes.checked,
                            }}
                            value={value}
                            name={`questionnaire[${currentStep}].answer[${index}]`}
                            onChange={() => {
                              toggleChecked(answer, index, onChange)
                            }}
                          />
                        }
                      />
                    </Grid>
                  )}
                />
              ))}
            </Grid>
          </FormGroup>
          <input
            type="hidden"
            ref={register()}
            name={`questionnaire[${currentStep}].question`}
            value="What is your availability?"
          />
          {/* <input */}
          {/*  type="hidden" */}
          {/*  ref={register()} */}
          {/*  name={`questionnaire[${currentStep}].intent`} */}
          {/*  value="true" */}
          {/* /> */}
          <NextButton variant="contained" color="primary" onClick={advance}>
            Next
          </NextButton>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default SelectAvailability
